import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';  
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';           
import { CaDisInfrastructuresService } from '@ascschool/services/category/caDisInfrastructures.service';
import { TutorTrainingAndRetrainingTypeService } from '@ascschool/services/new/tutor-training-and-retraining-type.service';
import { GeneralCategory } from '@ascschool/model/category/general-category.model';
@Component({
  selector: 'app-popup-dtbdcsgdhtgd',
  templateUrl: './popup-dtbdcsgdhtgd.component.html',
  styleUrls: ['./popup-dtbdcsgdhtgd.component.scss']
})
export class PopupDtbdcsgdhtgdComponent implements OnInit {
  @Input() value: any;
  isEditMode = false;
  @ViewChild("form", { static: false }) formElement: ElementRef;
  degreeItem = new GeneralCategory();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  constructor(
    private modal: NzModalRef,
    private msg: NzMessageService,
    public utilsService: UtilsService,
    private service: TutorTrainingAndRetrainingTypeService,
    private fb: FormBuilder,
  ) {
  }

  ngOnInit() {
    if (this.value && this.value.id > 0) {
      this.GetById(this.value.id);
      this.isEditMode = true;
      this.degreeItem.id = this.value.id;
      // console.log(this.degreeItem);
      this.validateForm = this.fb.group({
        id : this.value.id,
        code: [this.value.code, [Validators.required]],
        name: [this.value.name, [Validators.required]],
        displayOrder: [this.value.displayOrder, [Validators.required]],
      });
    } else {
      this.degreeItem = new GeneralCategory();
      this.isEditMode = false;
      this.validateForm = this.fb.group({
        code: [null, [Validators.required]],
        name: [null, [Validators.required]],
        displayOrder: [1],
      });
    }

  }
  GetById(id: number){
    this.service.getById(id).subscribe((res: any) => {
      
      this.degreeItem = res;
    });
  }
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  UpdateClose(){
  
    if (this.validateForm.valid){
      this.degreeItem = this.validateForm.value;  
      this.service.addOrUpdate(this.degreeItem).subscribe((res) => {
        if (res.statusCode === 0){
          this.notification(res);
          this.close();
        }else{
          this.notification(res);
        }
      }, error => {
        this.msg.error('lỗi: ' + error.error.Message);
      }
      );
    }else{
      this.utilsService.findInvalidControlsbyForm(this.validateForm,this.formElement);
    }
  }
  notification(response){
    if (response.statusCode === 0){
      this.msg.success('Cập nhật thông tin: ' + response.message);
    }else{
      this.msg.error('Lỗi: ' + response.message);
    }
  }
}
